module.exports = __webpack_public_path__ + "static/media/st.7435c162.svg";